import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-14",
  "use": "menu-14-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu-14\"><defs><style>#menu-14 .cls-1{fill:none}</style></defs><title>资源 60</title><g id=\"menu-14_图层_2\" data-name=\"图层 2\"><g id=\"menu-14_图层_1-2\" data-name=\"图层 1\"><g id=\"menu-14_code-square-o\"><path id=\"menu-14_Shape\" d=\"M3.17 22.49a1.69 1.69 0 0 1-1.68-1.69V3.17a1.68 1.68 0 0 1 1.68-1.68H20.8a1.69 1.69 0 0 1 1.69 1.68V20.8a1.69 1.69 0 0 1-1.69 1.69zm0-1.69H20.8V5.15H3.17zm14.28-3.95H12.8a.85.85 0 0 1 0-1.69h4.65a.85.85 0 1 1 0 1.69zm-9.7-.25a.86.86 0 0 1 0-1.19l2.7-2.71-2.7-2.7a.85.85 0 0 1 1.14-1.28l.11.07 3.29 3.33a.83.83 0 0 1 0 1.18L9 16.6a.84.84 0 0 1-1.19 0z\" /></g><path id=\"menu-14_Rectangle_47_Copy\" data-name=\"Rectangle 47 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-14.svg
// module id = g5FX
// module chunks = 6